import { Mutations } from 'vuex-smart-module';
import { PaginationProps, TableOptions } from '@/types';
import { default_pagination_props, default_table_opts } from '@/utils';
import { BaseState } from './base-state';

export class BaseMutations<S extends BaseState> extends Mutations<S> {
  SET_TABLE_OPTIONS(opts: TableOptions) {
    this.state.table_options = opts;
  }

  UPD_PAGINATION_FIELD({ key, value }: { key: keyof PaginationProps, value: number }) {
    this.state.pagination_props[key] = value;
  }

  UPD_TABLE_OPTIONS({ key, value }: { key: keyof TableOptions, value: unknown }) {
    this.state.table_options[key] = value;
  }

  RESET_TABLE_OPTIONS() {
    this.state.pagination_props = default_pagination_props();
    this.state.table_options = default_table_opts();
  }
}
